// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneCutTranslationFragmentDoc } from './stoneCutTranslation.fragment.generated';
export const StoneCutFragmentDoc = gql`
    fragment stoneCut on StoneCut {
  systemCode
  translation(locale: $locale) {
    ...stoneCutTranslation
  }
}
    ${StoneCutTranslationFragmentDoc}`;